import { Component } from "react";

export default class TransactionsTableButtons extends Component {
  soSomething = () => {
    let selected = this.props.getSelected();
    // eslint-disable-next-line no-console
    console.log(selected);
  };

  render() {
    return <div></div>;
  }
}
